import type { Meta, StoryFn } from '@storybook/react';
import type { MetaDataBarProps } from './MetaDataBar';
import type { IconProps } from 'components/Icon';

import { MetaDataBar } from './MetaDataBar';

const codeString = '<MetaDataBar itemData={itemData} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/MetaDataBar',
  component: MetaDataBar,
  parameters: {
    inspectComponent: MetaDataBar,
    codeString: codeString,
  },
} as Meta<MetaDataBarProps>;

const Template: StoryFn<MetaDataBarProps> = (args) => <MetaDataBar {...args} />;

export const MetaDataBarExample = Template.bind({});
MetaDataBarExample.args = {
  itemData: [
    { iconName: 'AcademicCap' as IconProps['name'], itemLabel: 'Jedi Academy' },
    { iconName: 'UserCircle' as IconProps['name'], itemLabel: 'Luuk Hemelwandelaar' },
  ],
};
